import axiosAuth from "@/services/axiosAuth";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import { QUALITY_CHECKLIST_API } from "../apiRoutes";

const mutateUpdateQualityChecklistItem = async ({
  checklistId,
  itemId,
  data,
}: {
  checklistId: string;
  itemId: string;
  data: FieldValues;
}) => {
  return await axiosAuth.put(
    `${QUALITY_CHECKLIST_API}/${checklistId}/items/${itemId}`,
    data
  );
};

const useUpdateQualityChecklistItemMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      checklistId: string;
      itemId: string;
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdateQualityChecklistItem,
    ...queryParams,
  });

export default useUpdateQualityChecklistItemMutation;
